module.exports = __webpack_public_path__ + "static/media/first-registration.6c19dbd0.jpg";